import { type SelectionRange } from '../../../state/types.ts';
import { type SelectionAxis } from '../../types.ts';

/**
 * Gets the minimum and maximum indices from a selection range for the given axis.
 * @param range - The selection range to analyze
 * @param axis - The axis to analyze ('row' or 'col')
 * @returns An object with min and max indices
 */
export function getRangeMinMax(
  range: SelectionRange,
  axis: SelectionAxis
): { min: number; max: number } {
  const anchorIndex = range.anchor[axis].index;
  const leadIndex = range.lead[axis].index;

  return {
    min: Math.min(anchorIndex, leadIndex),
    max: Math.max(anchorIndex, leadIndex)
  };
}
